import _ from 'lodash';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Button } from 'react-bootstrap';
import DealContext from '../DealContext';
import { getSalesRoles } from '../util';
import QuoteDocumentExpressPreview from '../QuoteDocumentExpressPreview';
import PostDealToAccounting from '../PostDealToAccounting';
import BatchActions from '../BatchActions';
import toastr from '../../toastr';
import ApiService from '../../../services/ApiService';
import { modal } from '../../modal/ModalEmitter';

const DealControls = () => {
  const user = useSelector(state => state.app.user);
  const { isSalesAccountant, isSalesManager } = getSalesRoles(user);

  const { deal, fetchDeal, quoteList } = useContext(DealContext);

  const openSupplemental = (template, dealId) => {
    if (!template) {
      return;
    }

    modal.open('quote-preview', {
      hidePrint: true,
      hideFooter: true,
      title: (
        <>
          <i className={template.icon || 'far fa-file-alt'} /> {template.name} (D{dealId})
        </>
      ),
      message: <QuoteDocumentExpressPreview dealId={dealId} templateId={template.id} />,
    });
  };

  const openBatchActions = () => {
    modal.open('batch-actions', {
      title: 'Batch Cancel',
      hidePrint: true,
      hideFooter: true,
      message: <BatchActions quoteList={quoteList} fetchDeal={fetchDeal} dealId={deal.id} />,
    });
  };

  const printDeal = () => {
    ApiService.get('crm/template/DealBuyersOrder')
      .then(response => {
        if (response.data && _.get(response.data, 'id')) {
          openSupplemental(response.data, deal.id);
        } else {
          toastr.error('Error', 'Unable to find document. Check if template exists and is properly grouped.');
        }
      })
      .catch(error => {
        toastr.error('Error', _.get(error, 'response.data.error'));
      });
  };

  const postDeal = () => {
    modal.open('postDealToAccounting', {
      hidePrint: true,
      title: `Post Deal [Ref ${deal.id}]`,
      headerClass: 'primary',
      message: <PostDealToAccounting dealId={deal.id} refreshDeal={fetchDeal} />,
    });
  };

  return (
    <Card>
      <Card.Body>
        <Row>
          <Col sm={12} md={12} lg={4} className="deal-control-wrapper">
            <Button onClick={printDeal} size="lg" className="deal-control" variant="secondary" block title="Print Deal">
              <i className="fa-solid fa-print fa-fw" />
            </Button>
          </Col>
          <Col sm={12} md={12} lg={4} className="deal-control-wrapper">
            <Button
              onClick={postDeal}
              className="deal-control"
              variant="secondary"
              block
              title="Post Deal"
              disabled={!isSalesAccountant}
            >
              <i className="fa-solid fa-paper-plane-top fa-fw" />
            </Button>
          </Col>
          <Col sm={12} md={12} lg={4} className="deal-control-wrapper">
            <Button
              onClick={openBatchActions}
              className="deal-control"
              variant="secondary"
              block
              title="Batch Cancel"
              disabled={!isSalesManager}
            >
              <i className="fas fa-minus-circle fa-fw" />
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default DealControls;
